import React from "react";
import { CartesianGrid } from "recharts";
import type { HorizontalCoordinatesGenerator } from "recharts/types/cartesian/CartesianGrid";

import { theme } from "~/tools/twin-migration";

const horizontalCoordinatesGenerator: HorizontalCoordinatesGenerator = ({ yAxis }) =>
	yAxis?.niceTicks?.map((tick) => yAxis.scale?.(tick) ?? 0) ?? [];

/**
 * Returns an empty array to disable vertical grid lines generation.
 */
const verticalCoordinatesGenerator = () => [];

export const Grid = React.memo(() => (
	<CartesianGrid
		horizontalCoordinatesGenerator={horizontalCoordinatesGenerator}
		stroke={theme("colors.gray.300")}
		vertical={false}
		verticalCoordinatesGenerator={verticalCoordinatesGenerator}
		zIndex={-500}
	/>
));
